import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';

const posts = [
  {
    slug: 'BlogPost1',
    title: 'The Ultimate Guide to Amazon FBA Palletization: Best Practices for 2024',
    summary: 'Learn how to palletize for Amazon FBA, private label, and wholesale. Best practices, requirements, and actionable tips for 2024.'
  },
  {
    slug: 'BlogPost2',
    title: 'How to Optimize Your Fulfillment Center Shipments for Maximum Efficiency',
    summary: 'Optimize your fulfillment center shipments for cost savings and efficiency. Strategies for Amazon FBA, 3PL, and more.'
  },
  {
    slug: 'BlogPost3',
    title: 'Private Label Shipping: Palletization Strategies for Growing Brands',
    summary: 'Discover palletization strategies for private label brands. Protect your products, reduce costs, and scale your business.'
  },
  {
    slug: 'BlogPost4',
    title: 'Wholesale Logistics: Reducing Costs with Smart Pallet Optimization',
    summary: 'Reduce wholesale shipping costs with smart pallet optimization. Learn strategies, tools, and actionable tips.'
  },
  {
    slug: 'BlogPost5',
    title: 'Carton Optimization: How to Maximize Space and Minimize Shipping Costs',
    summary: 'Maximize space and minimize shipping costs with carton optimization. Best practices and tools for every business.'
  },
  {
    slug: 'BlogPost6',
    title: 'Supply Chain Success: The Role of Palletization in Modern E-Commerce',
    summary: 'See how palletization drives supply chain success in e-commerce. Improve efficiency, reduce costs, and delight customers.'
  },
  {
    slug: 'BlogPost7',
    title: 'Amazon FBA Prep: Avoiding Common Palletization Mistakes',
    summary: 'Avoid common palletization mistakes in Amazon FBA prep. Learn compliance, labeling, and optimization tips.'
  },
  {
    slug: 'BlogPost8',
    title: 'Choosing the Right Pallet Size for Your Business: FCL, LCL, and More',
    summary: 'Choose the right pallet size for FCL, LCL, and more. Optimize shipping for Amazon FBA, wholesale, and global markets.'
  },
  {
    slug: 'BlogPost9',
    title: 'How 2D Visualization Tools Improve Pallet Loading and Shipping',
    summary: 'Discover how 2D visualization tools can improve pallet loading, reduce costs, and streamline your shipping process.'
  },
  {
    slug: 'BlogPost10',
    title: 'Exporting to Amazon FBA: Compliance, Labeling, and Palletization Tips',
    summary: 'Export to Amazon FBA with confidence. Learn compliance, labeling, and palletization best practices.'
  }
];

export default function BlogIndex() {
  return (
    <>
      <div className="max-w-4xl mx-auto py-8 sm:py-16 px-4">
        <h1 className="text-3xl sm:text-4xl font-bold mb-6 sm:mb-8 text-center">Palletization & FBA Blog</h1>
        <p className="text-base sm:text-lg text-gray-600 mb-8 sm:mb-12 text-center px-4">
          Expert tips, strategies, and best practices for Amazon FBA, fulfillment center logistics, private label, wholesale, and supply chain optimization.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8">
          {posts.map(post => (
            <div key={post.slug} className="bg-white rounded-xl shadow-md p-4 sm:p-6 hover:shadow-lg transition-shadow flex flex-col justify-between">
              <div>
                <h2 className="text-xl sm:text-2xl font-semibold mb-2">{post.title}</h2>
                <p className="text-gray-600 mb-4 text-sm sm:text-base">{post.summary}</p>
              </div>
              <Link
                to={`/blog/${post.slug}`}
                className="inline-block mt-2 text-blue-600 font-semibold hover:underline"
              >
                Read More →
              </Link>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
} 